import lrUserMultiSelect from './_src/lrUserMultiSelect.vue'
lrUserMultiSelect.install = function(Vue) {
  Vue.component(lrUserMultiSelect.name, lrUserMultiSelect)
}
export default lrUserMultiSelect